module.exports = __webpack_public_path__ + "img/kfwx.9913872f.png";